var map = {
	"./CartwheelGalaxy_JWST.jpg": 195,
	"./CartwheelGalaxy_hubble.jpg": 303,
	"./CartwheelGalaxy_thumb.jpg": 88,
	"./CosmicCliffs_JWST.jpg": 855,
	"./CosmicCliffs_hubble.jpg": 895,
	"./CosmicCliffs_thumb.jpg": 804,
	"./PillarsOfCreation_JWST.jpg": 424,
	"./PillarsOfCreation_hubble.jpg": 857,
	"./PillarsOfCreation_thumb.jpg": 249,
	"./SouthernRingNebula_JWST.jpg": 960,
	"./SouthernRingNebula_hubble.jpg": 140,
	"./SouthernRingNebula_thumb.jpg": 886,
	"./TarantulaNebula_JWST.jpg": 614,
	"./TarantulaNebula_hubble.jpg": 251,
	"./TarantulaNebula_thumb.jpg": 359,
	"./jupiter_JWST.jpg": 998,
	"./jupiter_hubble.jpg": 991,
	"./jupiter_thumb.jpg": 883,
	"./test-images/test-compare-1.jpg": 474,
	"./test-images/test-compare-10.jpg": 869,
	"./test-images/test-compare-11.jpg": 260,
	"./test-images/test-compare-12.jpg": 473,
	"./test-images/test-compare-2.jpg": 943,
	"./test-images/test-compare-3.jpg": 185,
	"./test-images/test-compare-4.jpg": 489,
	"./test-images/test-compare-5.jpg": 98,
	"./test-images/test-compare-6.jpg": 50,
	"./test-images/test-compare-7.jpg": 509,
	"./test-images/test-compare-8.jpg": 302,
	"./test-images/test-compare-9.jpg": 544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;